export enum DossierActions {
  fetchDossier = '[Dossiers]: fetch dossier',
  fetchDossierSuccess = '[Dossiers]: fetch dossier success',
  fetchDossierFailure = '[Dossiers]: fetch dossier failure',

  fetchDossierData = '[Dossiers]: fetch dossier data',
  fetchDossierDataSuccess = '[Dossiers]: fetch dossier data success',
  fetchDossierDataFailure = '[Dossiers]: fetch dossier data failure',

  updateDossierHeader = '[Dossiers]: update dossier header',
  updateDossierHeaderSuccess = '[Dossiers]: update dossier header success',
  updateDossierHeaderFailure = '[Dossiers]: update dossier header failure',

  fetchAvailableStatuses = '[Dossiers]: fetch available statuses',
  fetchAvailableStatusesSuccess = '[Dossiers]: fetch available statuses success',
  fetchAvailableStatusesFailure = '[Dossiers]: fetch available statuses failure',

  addDocument = '[Dossiers]: add document',

  removeDocument = '[Dossiers]: remove document',
  removeDocumentSuccess = '[Dossiers]: remove document success',
  removeDocumentFailure = '[Dossiers]: remove document failure',

  addRelation = '[Dossiers]: add relation',
  addRelationSuccess = '[Dossiers]: add relation success',
  addRelationFailure = '[Dossiers]: add relation failure',

  removeRelation = '[Dossiers]: remove relation',
  removeRelationSuccess = '[Dossiers]: remove relation success',
  removeRelationFailure = '[Dossiers]: remove relation failure',

  addLink = '[Dossiers]: add link',
  addLinkSuccess = '[Dossiers]: add link success',
  addLinkFailure = '[Dossiers]: add link failure',

  removeLink = '[Dossiers]: remove link',
  removeLinkSuccess = '[Dossiers]: remove link success',
  removeLinkFailure = '[Dossiers]: remove link failure',

  addInvolved = '[Dossiers]: add involved',
  addInvolvedSuccess = '[Dossiers]: add involved success',
  addInvolvedFailure = '[Dossiers]: add involved failure',

  removeInvolved = '[Dossiers]: remove involved',
  removeInvolvedSuccess = '[Dossiers]: remove involved success',
  removeInvolvedFailure = '[Dossiers]: remove involved failure'
}
